import { useFadeIn } from '@hooks/useFadeIn'
import { profile } from '@content/portfolioData'
import { storyInsights } from '@content/storyInsights'

export function About() {
  const fade = useFadeIn()
  const insight = storyInsights.about[0]

  return (
    <section id="about" ref={fade.ref as React.RefObject<HTMLElement>} className={`modern-section ${fade.className}`}>
      <p className="modern-section__label">About</p>
      <h2 className="modern-section__title">AI tools, built accessibly</h2>
      <div className="modern-about__grid">
        <div>
          <p className="modern-about__text">
            {profile.bio} At {profile.company}, I build practical AI tools
            with a focus on accessibility and honest, transparent development.
          </p>
          <p className="modern-about__text" style={{ marginTop: '1rem' }}>
            {profile.philosophy} &mdash; Under-promise, over-deliver. Share what
            works and what doesn't. Build in public, learn in the open.
          </p>
          {insight && (
            <blockquote className="modern-about__insight">
              {insight.quote}
              {insight.attribution && (
                <cite className="modern-about__insight-cite">{insight.attribution}</cite>
              )}
            </blockquote>
          )}
        </div>
        <ul className="modern-about__mission">
          {profile.mission.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}
